import {
    BasicInfoBeneficiary,
    SupplierServiceForm,
} from './components';

export const stepsServiceSupplier = [
  {
    name: 'SUPPLIERSERVICEFORM',
    label: 'Υπηρεσία',
    Component: SupplierServiceForm,
    id: 0,
  },
];